import { Stack } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
import { ClientPaginatedTable } from 'components/table';
import * as TableConfig from 'sections/MainDashboard/categoriesPages/tablesConfig';
import { selectTranslations } from 'state/reducers/translation.reducers';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserDetails } from 'state/reducers/user.reducers';
import { getCompanies, getCurrencies, getCountries } from 'state/reducers/global.reducer';
import { DashboardCategories } from 'constants/balance.constants';
import { timing } from 'constants/ui.constants';
import { FormButton } from 'theme/elements/Buttons';
import { ButtonComponent } from 'components/ButtonComponent';
import { getBalancesAndFeesXlsx } from 'services/reports.service';
type props = {
	type: DashboardCategories;
	data: any[];
};
export const PageTable: React.FC<props> = (props: props) => {
	const { type, data } = props;
	const companies = useAppSelector(getCompanies);
	const currencies = useAppSelector(getCurrencies);
	const countries = useAppSelector(getCountries);
	const t = useAppSelector(selectTranslations);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { permissions } = useAppSelector(getUserDetails);
	const filters = useAppSelector((state) => state.dashboard.filters);

	const handleDownloadClick = () => {
		if (type === 'customerBalances') {
			dispatch(getBalancesAndFeesXlsx(type, filters, countries, false));
		} else {
			dispatch(getBalancesAndFeesXlsx(type, filters, countries, true));
		}
	};
	const dontShowCategories = [
		DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS,
		DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS,
	];

	return (
		<>
			{data && (
				<>
					<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
						{!dontShowCategories.includes(type) && (
							<FormButton>
								<ButtonComponent handleClick={handleDownloadClick} text={t('report.excelDownload')} />
							</FormButton>
						)}
					</div>
					<ClientPaginatedTable
						{...TableConfig.getRowAction(type as DashboardCategories, navigate)}
						defaultSortBy="createdAt"
						defaultOrderBy="desc"
						data={TableConfig.tableData(type, data, t, companies, currencies)}
						columns={TableConfig.buildColumns(type, t, currencies, countries, data)}
						dateFormat={timing.DATE}
					/>
				</>
			)}
		</>
	);
};
